import React from 'react';
import './LoadingOverlay.css';

// Overlay — tüm ekranı kaplar (yoğun işlemlerde)
export const LoadingOverlay = ({ message = 'Yükleniyor...' }) => (
  <div className="loading-overlay">
    <div className="loading-overlay-content">
      <svg className="spinner-gold" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="19" stroke="rgba(200,168,75,0.25)" strokeWidth="4.5" fill="none"/>
        <path d="M24 5 a19 19 0 0 1 19 19" stroke="#c8a84b" strokeWidth="4.5" fill="none" strokeLinecap="round">
          <animateTransform attributeName="transform" type="rotate" from="0 24 24" to="360 24 24" dur="0.85s" repeatCount="indefinite"/>
        </path>
      </svg>
      <span className="loading-overlay-text">{message}</span>
    </div>
  </div>
);

// Inline — içerik içinde küçük spinner
export const LoadingInline = ({ message = 'Yükleniyor...' }) => (
  <div className="loading-inline">
    <svg className="spinner-inline" width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="8" stroke="var(--color-border, #ddd)" strokeWidth="2.5" fill="none"/>
      <path d="M11 3 a8 8 0 0 1 8 8" stroke="var(--navy, #0f1f3d)" strokeWidth="2.5" fill="none" strokeLinecap="round">
        <animateTransform attributeName="transform" type="rotate" from="0 11 11" to="360 11 11" dur="0.85s" repeatCount="indefinite"/>
      </path>
    </svg>
    {message && <span className="loading-inline-text">{message}</span>}
  </div>
);

export default LoadingOverlay;
